module.exports = function () {
  this.app.$on('getPin', event => {
    let countryCode = event.countryCode.toString()
    if (countryCode.indexOf('+') > -1) {
      countryCode = countryCode.substr(1)
    }
    const expected = (`${event.phone}${countryCode.replaceAll('+', '')}` >> 2) * 5
    // this.sdk.post('/auth/sms/send', {
    this.sdk.post('/auth/sms/code', {
      phone: event.phone,
      countryCode: event.countryCode,
      code: expected,
      nationalNumber: event.phone
    }, response => {
      if (!response.notes) {
      // if (response.success) {
        this.app.$emit('getPinSuccess', event)
      } else {
        this.app.$emit('getPinFail')
      }
    }, '/1.1')
    // })
  })

  this.app.$on('verifyPin', event => {
    this.sdk.post('/auth/sms/verify', {
      phone: event.phone,
      countryCode: event.countryCode,
      smsCode: event.smsCode
    }, response => {
      if (response.success) {
        this.app.$emit('mobileVerifySuccess')
      } else {
        this.app.$emit('mobileVerifyFail')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/events/verify-mobile.js